import { useEffect, useRef, useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";

const fmt = (d) => new Date(d).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });

// Shared 1:1 chat thread; `mine` is the sender role of the current viewer.
export const ChatThread = ({ load, sendFn, mine, emptyText, testPrefix = "support" }) => {
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const box = useRef(null);
  const count = useRef(0);

  useEffect(() => {
    let alive = true;
    const tick = () => load().then((d) => alive && setMsgs(d)).catch(() => {});
    tick();
    const t = setInterval(tick, 3000);
    return () => { alive = false; clearInterval(t); };
  }, [load]);
  useEffect(() => {
    if (msgs.length !== count.current) box.current?.scrollTo({ top: box.current.scrollHeight, behavior: "smooth" });
    count.current = msgs.length;
  }, [msgs]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    try {
      const m = await sendFn(text);
      setMsgs((x) => [...x, m]);
      setText("");
    } catch (err) { toast.error(errMsg(err, "Invio non riuscito")); }
  };

  return (
    <div className="flex flex-col h-full min-h-0">
      <div ref={box} className="flex-1 overflow-y-auto space-y-3 p-4" data-testid={`${testPrefix}-messages`}>
        {msgs.length === 0 && <p className="text-sm text-slate-500 text-center py-10">{emptyText}</p>}
        {msgs.map((m) => (
          <div key={m.id} className={`flex ${m.sender === mine ? "justify-end" : "justify-start"}`}>
            <div className={`max-w-[80%] rounded-2xl px-4 py-2.5 text-sm ${m.sender === mine ? "bg-cyan-500/20 border border-cyan-400/30 rounded-br-md" : "bg-violet-500/15 border border-violet-400/25 rounded-bl-md"}`}>
              <p className="text-[10px] font-mono uppercase tracking-widest text-slate-400 mb-1">{m.sender_name} · {fmt(m.created_at)}</p>
              <p className="whitespace-pre-wrap text-slate-100">{m.text}</p>
            </div>
          </div>
        ))}
      </div>
      <form onSubmit={send} className="p-3 border-t border-cyan-500/15 flex gap-2">
        <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Scrivi un messaggio…" data-testid={`${testPrefix}-input`}
          className="flex-1 bg-[#050b18]/80 border border-cyan-500/25 rounded-xl px-4 py-2.5 text-sm outline-none focus:border-cyan-400/60" />
        <button className="btn-aurora rounded-xl px-4" data-testid={`${testPrefix}-send-btn`}><Send size={16} /></button>
      </form>
    </div>
  );
};
